import ComponentElement from 'components/component-element';

function Typer($element, options = {}) {
    ComponentElement.call(this, $element, options);

    this.place = this.options.place; // место, куда будет вводиться текст
    this.texts = this.options.texts;
    this.speed = this.options.speed;
    this.delay = this.options.delay; // задержка между печатанием и удалением
    this.loop = this.options.loop;
}


Typer.prototype = Object.create(ComponentElement.prototype);
Object.defineProperty(Typer.prototype, 'constructor', {
    value: Typer,
    enumerable: false,
    writable: true,
});

// задержка между печатанием и удалением
Typer.prototype.wait = function() {
    return new Promise((resolve) => setTimeout(resolve, this.delay));
}

Typer.prototype.typing = function(text) {
    let toIndex = 0;

    return new Promise((resolve) => {
        const intervalId = setInterval(() => {
            this.$element[this.place] = text.substring(0, toIndex);
    
            if (toIndex >= text.length) {
                clearInterval(intervalId);

                resolve();
            }

            toIndex++;
        }, this.speed);
    });
}

Typer.prototype.deleting = function(text) {
    let toIndex = text.length;

    return new Promise((resolve) => {
        const intervalId = setInterval(() => {
            this.$element[this.place] = text.substring(0, toIndex);
        
            if (toIndex < 1) {
                clearInterval(intervalId);
    
                resolve();
            }
    
            toIndex--;
        }, this.speed);
    });
}

Typer.prototype.start = async function(index = 0) {
    const text = this.texts[index];
    
    await this.typing(text);
    
    if (index < this.texts.length - 1) {
        await this.wait();
        await this.deleting(text);
        
        return this.start(index + 1);
    }

    if (this.loop) {
        await this.wait();
        await this.deleting(text);

        this.start();
    }
}

export default Typer;
